export const URI_TASK_SERVER = process.env.REACT_APP_URI_TASK_SERVER || 'ws://localhost:8080/'
export const BASENAME = process.env.REACT_APP_BASENAME || '/'
